/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface LinkCustomerToTabRequest {
    tabId: string;
    phoneNumber: string;
}

export interface LinkRoomToTabRequest {
    tabId: string;
    roomName: string;
}

/**
 * 
 */
export class TabsApi extends runtime.BaseAPI {

    /**
     */
    async linkCustomerToTabRaw(requestParameters: LinkCustomerToTabRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError(
                'tabId',
                'Required parameter "tabId" was null or undefined when calling linkCustomerToTab().'
            );
        }

        if (requestParameters['phoneNumber'] == null) {
            throw new runtime.RequiredError(
                'phoneNumber',
                'Required parameter "phoneNumber" was null or undefined when calling linkCustomerToTab().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/tabs/{tabId}/link-customer/{phoneNumber}`.replace(`{${"tabId"}}`, encodeURIComponent(String(requestParameters['tabId']))).replace(`{${"phoneNumber"}}`, encodeURIComponent(String(requestParameters['phoneNumber']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async linkCustomerToTab(requestParameters: LinkCustomerToTabRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.linkCustomerToTabRaw(requestParameters, initOverrides);
    }

    /**
     */
    async linkRoomToTabRaw(requestParameters: LinkRoomToTabRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError(
                'tabId',
                'Required parameter "tabId" was null or undefined when calling linkRoomToTab().'
            );
        }

        if (requestParameters['roomName'] == null) {
            throw new runtime.RequiredError(
                'roomName',
                'Required parameter "roomName" was null or undefined when calling linkRoomToTab().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/tabs/{tabId}/link-room/{roomName}`.replace(`{${"tabId"}}`, encodeURIComponent(String(requestParameters['tabId']))).replace(`{${"roomName"}}`, encodeURIComponent(String(requestParameters['roomName']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async linkRoomToTab(requestParameters: LinkRoomToTabRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.linkRoomToTabRaw(requestParameters, initOverrides);
    }

}
